import React from 'react';
import styles from './Modal.module.css';

/**
 * ModalHeader Component
 *
 * Header section for Modal component
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Header content
 * @param {string} props.className - Additional CSS classes
 */
const ModalHeader = ({ children, className = '' }) => {
  const headerClasses = [styles.header, className].filter(Boolean).join(' ');

  return <div className={headerClasses}>{children}</div>;
};

export default ModalHeader;
